import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Information from "@/components/Information.tsx";

import { useLang } from "@/hooks/useLang";
import LicenseRu from "@/policy/ru/license.md?raw";
import LicenseUz from "@/policy/uz/license.md?raw";

const LisencePage = (): JSX.Element => {
  const lang = useLang();
  const { t } = useTranslation();

  const markdown = lang == "uz" ? LicenseUz : LicenseRu;

  return <Information title={t("user-agreement")} markdown={markdown} />;
};

export default LisencePage;
